
const actions = {

  /*  getUser () {},

    patchUser () {},

    deleteUser () {}*/
}

export default actions



// WEBPACK FOOTER //
// ./src/store/actions.js